import React, { FC } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import { useExtrasPageLinkWithFallback } from '../../booking-steps/extras/helpers/useExtrasPageLinkWithFallback';
import { Payment } from '../../booking-steps/payment/Payment';
import { BookingPageLayout } from '../shared/BookingPageLayout';
import { useHideChatBot } from '../../../../chatbot/helpers/useHideChatBot';

export const FullAmendPaymentPage: FC = () => {
	useHideChatBot('mobile');
	const { t } = useTranslation();
	const extrasUrl = useUrlForPageId(ParkingPageId.FullAmendBookingExtras);
	const availabilityUrl = useUrlForPageId(
		ParkingPageId.FullAmendBookingAvailability,
	);
	const nextUrl = useUrlForPageId(ParkingPageId.FullAmendBookingConfirmation);

	const parentLink = useExtrasPageLinkWithFallback({
		extrasTitle: t('web_parking_modify_payment_back_button'),
		extrasUrl,
		fallbackTitle: t('web_parking_modify_payment_back_button_no_extras'),
		fallbackUrl: availabilityUrl,
	});

	const parkingOptionsUrl = useUrlForPageId(
		ParkingPageId.FullAmendBookingAvailability,
	);

	return (
		<BookingPageLayout
			parentUrl={parentLink.url}
			parentTitle={parentLink.title}
			title={t('web_parking_modify_payment_header')}
		>
			<Payment
				nextUrl={nextUrl}
				sessionExpiredNextUrl={availabilityUrl}
				changeButtonUrl={parkingOptionsUrl}
			/>
		</BookingPageLayout>
	);
};
